<div class="table-scroll">
    <table [formGroup]="tableForm" class="lab-table">
        <thead class="sticky-top">
            <tr>
                <th class="first-cell sticky-left">
                    {{ to.headerRow?.label }}
                </th>

                @for (col of tableModel.columns; track col.id; let i = $index) {
                <th>
                    <div class="flex gap-2 items-center">
                        <div class="flex flex-col gap-1">
                            <vui-datepicker class="w-40" [classes]="['v2-form-field']" [form]="tableForm"
                                [controlName]="columnDateKey(col)">
                            </vui-datepicker>

                            @if (tableForm.get(columnDateKey(col))?.hasError('dateNotInFuture')) {
                            <mat-error class="text-xs">
                                Data não pode ser futura
                            </mat-error>
                            }
                        </div>

                        @if (i !== 0) {
                        <button mat-icon-button (click)="removeColumn(col)">
                            <mat-icon svgIcon="trash"></mat-icon>
                        </button>
                        }
                    </div>
                </th>
                }

                <th class="last-cell last-column">
                    <v2-button-wrapper color="accent" variant="flat" [text]="to.addColumnText" (click)="addColumn()" />
                </th>
            </tr>
        </thead>

        <tbody>
            @for (row of tableModel.rows; track row.__id; let i = $index) {
            <tr>
                <td class="first-cell sticky-left">
                    @if (row.__locked) {
                    <strong>{{ row.__label }}</strong>
                    } @else {
                    <mat-form-field class="v2-form-field w-40">
                        <input matInput [formControl]="rowLabelControl(row)" />
                    </mat-form-field>
                    }
                </td>

                @for (col of tableModel.columns; track col.id) {
                <td>
                    <mat-form-field class="v2-form-field w-50">
                        <input matInput [formControl]="getCellControl(row, col)" [disabled]="row.__locked" />
                    </mat-form-field>
                </td>
                }

                <td class="last-cell last-column">
                    @if (!row.__locked) {
                    <button mat-icon-button (click)="removeRow(i)">
                        <mat-icon svgIcon="trash"></mat-icon>
                    </button>
                    }
                </td>
            </tr>
            }

            <tr>
                <td class="first-cell sticky-left">
                    <v2-button-wrapper color="accent" variant="flat" [text]="to.addRowText" (click)="addRow()" />
                </td>

                <td [attr.colspan]="tableModel.columns.length"></td>
                <td class="last-cell last-column"></td>
            </tr>
        </tbody>
    </table>
</div>